<template>
  <div>
    <Header></Header>
    <div :class="[getBlackWindows ? 'overload' : '']"></div>
    <div class="layout_body">
      <router-view></router-view>
    </div>
    <Footer class="pt-10"></Footer>
    <AlertDialogWS></AlertDialogWS>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
import { mapActions, mapGetters } from 'vuex'
import Footer from "@/components/Footer.vue";
import AlertDialogWS from '../../components/alerts/AlertDialogWS.vue';
export default {
  name: 'Panel',
  components: {
    Header,
    Footer,
    AlertDialogWS
  },
  async mounted() {
    // Si el token ha expirado cierre sesión
    if(await this.tokenHasExpired()) {
      this.signOut();
    }
    await this.queryUser()
    await this.queryRol()
  },
  methods: {
    ...mapActions(['queryUser', 'queryRol', 'signOut', 'tokenHasExpired']),
  },
  computed: {
    ...mapGetters(['getBlackWindows']),
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/base';
.layout_body {
  padding: 70px 15px 0 15px;
  min-height: 90vh;
}
</style>
